import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root'
})


export class SettingsService {


  public static API_ENDPOINT:string = environment.API_ENDPOINT;
  public static lemu_base:string = environment.lemu_base;
  public static WS_URL:string = environment.WS_URL;

  validateQuery(query: string): string {
    if (!query.startsWith('/')) {
      query = '/' + query;
    }
    return query;
  }


  get_query(http: number, query: string, value: any = {}, wo_options: boolean = false) {

    query = this.validateQuery(query);
    const endpoint = `${SettingsService.API_ENDPOINT}${query}`;
    const token = this.get_token();

    const headers: any = new HttpHeaders().set("Authorization", "JWT " + token);
    let req: any = new Observable();

    switch (http) {
      case 1:
        req = wo_options ? this.http.get(endpoint, { observe: 'response' }) : this.http.get(endpoint, { headers, observe: 'response' });
        break;
      case 2:
        req = wo_options ? this.http.post(endpoint, value, { observe: 'response' }) : this.http.post(endpoint, value, { headers, observe: 'response' });
        break;
      case 3:
        req = wo_options ? this.http.put(endpoint, value, { observe: 'response' }) : this.http.put(endpoint, value, { headers, observe: 'response' });
        break;
      case 4:
        req = this.http.delete(endpoint, { headers, observe: 'response' });
        break;
      default:
        req = wo_options ? this.http.get(endpoint, { observe: 'response' }) : this.http.get(endpoint, { headers, observe: 'response' });
        break;
    }

    return new Promise((resolve, reject) => {
      req.subscribe(
        (response: HttpResponse<any>) => {
          var status = response.status;
          //hay muchos endpoint que solo tienen 200 en el switch case, y hay respuestas que marcan 201,
          //para corregir temporalmente esto, se asignaran todas las respuestas positivas a 200
          if(status == 201){
            status = 200;
          }
          const body = response.body;
          resolve({ '_body':body, 'status':status });
        },
        (_error: any) => {
          const statusCode = _error.status;
          const status = statusCode
          const error = _error.error
          const _body = _error;
          reject({ _body, error, statusCode, status });
        }
      );
    });
  }



  manage_errors(status:any, view:any, body:any, show_dialog_errors=true) {
    switch (status) {
      case 400:
        if (show_dialog_errors) {
          console.log(body, view);
        }
      break;
      case 404:
        this.snackBar.open("Si tienes problemas para ingresar comunícate con el área de soporte o tu ejecutivo", "Aceptar", {
          duration: 20000,
          panelClass: "simpli-snack"
        });
      break;
      case 500:
        this.snackBar.open("Ocurrió un error, intenta de nuevo", "Aceptar", {
          duration: 20000,
          panelClass: "simpli-snack"
        });
        this.send_mail_500(view, body);
      break;
      default:

      break;
    }
  }

  async send_mail_500(view:any, body:any) {
    try {
      var value = {
        "view": view,
        "status": body.status,
        "statusText": body.statusText,
        "type": body.type,
        "url": body.url,
        "body": body._body,
      }
      const bd: any = await this.get_query(2, 'cliente-inversionista/alert-fail/', value, true);
      var body_data: any =bd._body;

      switch (bd.status) {
        case 200:

        break;
        default:

        break;
      }

    } catch (bd: any) {

    }
  }


  verify_out() {
    if (localStorage.getItem("token") != null) {
      this.router.navigate(['home']);
    }
  }

  get_token(sw = null) {
    return localStorage.getItem("token");
  }

  empty_local_data() {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    this.router.navigate(['login']);
  }



  constructor(private router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, private http: HttpClient) {

  }
}
